var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',[_c('div',{staticClass:"columns is-12"},[_vm._m(1),_c('div',{staticClass:"column is-10"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.description)}})])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"title has-text-centered"},[_vm._v("Introduction Test")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"column is-2"},[_c('b',[_vm._v("Introduction")])])
}]

export { render, staticRenderFns }